import { render, staticRenderFns } from "./staff-apply.vue?vue&type=template&id=69f221f6&scoped=true&"
import script from "./staff-apply.vue?vue&type=script&lang=js&"
export * from "./staff-apply.vue?vue&type=script&lang=js&"
import style0 from "./staff-apply.vue?vue&type=style&index=0&id=69f221f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f221f6",
  null
  
)

export default component.exports